<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mb-3">
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" exact :to="tabRoute('overview')">Resumen</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" exact :to="tabRoute('receivables')">Ingresos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" exact :to="tabRoute('subscriptions')">Suscripciones</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" exact :to="tabRoute('invoicing')">Facturación</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" exact :to="tabRoute('custom')"><v-icon class="icon-rotate" left size="18">mdi-pin</v-icon>{{ customTabLabel }}</v-tab>
        </v-tabs>
      </v-card>

      <overview-tab v-if="tabKey === 'overview'" />
      <receivables-tab v-else-if="tabKey === 'receivables'" />
      <subscriptions-tab v-if="tabKey === 'subscriptions'" />
      <invoicing-tab v-else-if="tabKey === 'invoicing'" />
      <custom-dashboard-tab v-else-if="tabKey === 'custom'" />
    </v-col>
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
import OverviewTab from '@/components/dashboard/OverviewTab'
import InvoicingTab from '@/components/dashboard/InvoicingTab'
import ReceivablesTab from '@/components/dashboard/ReceivablesTab'
import CustomDashboardTab from '@/components/dashboard/CustomDashboardTab'
import SubscriptionsTab from '@/components/dashboard/SubscriptionsTab.vue'

export default {
  components: {
    OverviewTab,
    SubscriptionsTab,
    InvoicingTab,
    ReceivablesTab,
    CustomDashboardTab
  },
  mixins: [GenericViewMixin],
  computed: {
    tabKey () {
      return this.$route.params.key || 'overview'
    },
    settings () {
      return this.$store.state.accountSettings.settings
    },
    defaultDashboard () {
      return this.$store.state.dashboards.dashboardsDetail
    },
    customTabLabel () {
      const id = this.settings && this.settings.default_dashboard
      if (id && this.defaultDashboard && this.defaultDashboard.id === id) {
        return this.defaultDashboard.name
      }
      return 'Mi Dashboard'
    }
  },
  created () {
    this.$store.dispatch('accountSettings/RETRIEVE')
      .then(settings => {
        if (settings && settings.default_dashboard) {
          this.$store.dispatch('dashboards/RETRIEVE', {
            resource: 'metrics/dashboards',
            id: settings.default_dashboard,
            loader: false
          }).catch(() => {})
        }
      })
      .catch(() => {})
  },
  methods: {
    tabRoute (key) {
      return { name: 'AccountDashboard', params: { key } }
    }
  }
}
</script>
<style>
.icon-rotate {
  transform: rotate(-30deg);
  margin-top: 2px !important;
}
</style>